import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Gumball Poodle (b_1fc44661), pulled from Faire's
// live `GET /api/product-reviews/product/{product_token}` endpoint (review
// token pr_k4ea8ecbzw) — verbatim comment, real reviewer first name, location and rating.
export const review_gp6: FaireReviewEntity = {
  token: "review_gp6",
  type: "review",
  brandName: "Gumball Poodle",
  brandToken: "b_1fc44661",
  productToken: "p_mqrz4rc9jd",
  reviewType: "product",
  reviewerName: "Nichole",
  reviewerLocation: "Cabot, AR, United States",
  stars: 5,
  reviewText: "Added this to a few items for Father’s Day! Quirky & cool for that, “Rad dad!”",
  reviewDate: "Jun 24, 2026",
  meta: {
    source: "api" as const,
    importedAt: "2026-10-12T05:40:00.000Z",
    importedBy: "entity-db-cli",
  },
};
